import axios from "axios";

const baseURL = import.meta.env.VITE_APP_API_URL;
// const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

export const apiInstance = axios.create({
  baseURL: baseURL,
});

// middle ware xử lý thêm token trước khi gửi đi request
apiInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token"); // Lấy token từ localStorage
    if (token) {
      config.headers.Authorization = `Bearer ${token}`; // Thêm Authorization header
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const handleApiError = (error) => {
  console.error("API Error:", error.response?.data || error?.message);
  // Ném ra lỗi để các hàm service cụ thể xử lý
  throw error;
};